$(document).ready(function(){

  /* $( "footer" ).hide(); */

});
